// Asignación en la SUITE — dos planos que NO se mezclan.
//
// 1) CUENTA (permanente): cliente ↔ un técnico. Solar Hub `asignarTecnico` /
//    FluxAI `tecnico_usuarios` (SQL 205). Sirve para “quién atiende a este usuario”.
// 2) OBRA (por cotización ganada): matching RETIE → técnico de ESTA instalación
//    + proveedor (PO). Vive en `quotes.technician_id` + orden de tipo instalacion.
//
// El cliente acepta la propuesta → nace la orden SIN técnico.
// El gestor asigna en Administración → hay que escribir las DOS: cotización y orden.

export function tecnicoDeOpciones(installers = [], sugerencias = []) {
  const map = new Map();
  for (const t of installers) {
    if (t?.id == null) continue;
    map.set(String(t.id), {
      id: t.id,
      name: t.name || t.nombre || t.company || `Instalador #${t.id}`,
      email: t.email || '',
      sub: t.dept || t.retie || '',
    });
  }
  for (const m of sugerencias) {
    if (m?.id == null) continue;
    map.set(String(m.id), {
      id: m.id,
      name: m.name || m.nombre || `Instalador #${m.id}`,
      email: m.email || map.get(String(m.id))?.email || '',
      sub: m.score != null ? `score ${m.score}` : (m.dept || ''),
    });
  }
  return [...map.values()];
}

/** Aplica el técnico de OBRA a la orden de instalación de esa cotización. */
export function ordenConTecnicoDeObra(ordenes, quoteId, tech) {
  if (!tech || quoteId == null) return null;
  const o = (ordenes || []).find((x) => String(x.quoteId) === String(quoteId) && x.tipo === 'instalacion');
  if (!o) return null;
  return {
    ...o,
    tecnicoId: tech.id,
    tecnicoNombre: tech.name || '',
    tecnicoEmail: tech.email || '',
    estado: o.estado === 'programada' ? 'asignada' : o.estado,
    notas: o.notas && /falta asignar técnico/i.test(o.notas)
      ? `Técnico asignado: ${tech.name || tech.email || tech.id}`
      : o.notas,
  };
}
